module.exports = __webpack_public_path__ + "img/search.c3cc7300.svg";